(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/_base/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/_base/pay.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PayBase extends svs.tur.payment.services.Events {
  constructor() {
    super();
    this.payableObj = undefined;
    if (PayBase.instances.length) {
      throw new Error("".concat(PayBase.instances.length, " instance already active!"));
    }
    PayBase.instances.push(this);
  }
  initialize() {
    if (!this.payableObj) throw Error('Missing payableObj');
    this.paymentCallInProgress = false;
    this.syndicate = this.getSyndicate();
    this.account = new svs.tur.payment.services.Account({
      syndicate: this.syndicate,
      returnParams: this.returnParams,
      onCancel: this.onCancel
    });
    this.account.checkStatus({
      price: this.price
    }).done(() => {
      this.onAccountStatusSuccess();
    }).catch(e => {
      this.onAccountStatusFailed(e);
    });
  }
  showConfirmDialog() {
    const {
      DIALOG_CONFIRM_SHOW
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(DIALOG_CONFIRM_SHOW);
    new svs.tur.payment.dialogs.PaymentConfirm(_objectSpread({
      onConfirm: () => {
        this.onPayConfirm();
      },
      onCancel: () => {
        this.onPayCancel();
        this.destroy();
      },
      syndicate: this.syndicate
    }, this.getConfirmDialogProps()));
    this.trigger(DIALOG_CONFIRM_SHOW);
  }
  onPayConfirm() {
    const {
      PAYMENT_CONFIRM
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(PAYMENT_CONFIRM);
    this.trigger(PAYMENT_CONFIRM);
    this.sendPayment();
  }
  onPayCancel() {
    const {
      PAYMENT_CANCEL
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(PAYMENT_CANCEL);
    this.trigger(PAYMENT_CANCEL);
  }
  isSyndicate() {
    return this.payableObj.syndicate;
  }
  getSyndicate() {
    var _this$payableObj$, _svs$syndicate;
    const syndicateId = Array.isArray(this.payableObj) ? (_this$payableObj$ = this.payableObj[0]) === null || _this$payableObj$ === void 0 ? void 0 : _this$payableObj$.syndicateId : this.payableObj.syndicateId;
    if ((_svs$syndicate = svs.syndicate) !== null && _svs$syndicate !== void 0 && (_svs$syndicate = _svs$syndicate.account_selector) !== null && _svs$syndicate !== void 0 && (_svs$syndicate = _svs$syndicate.data) !== null && _svs$syndicate !== void 0 && _svs$syndicate.syndicates) {
      return svs.syndicate.account_selector.data.syndicates.find(s => s.syndicateId === syndicateId);
    }
    return false;
  }

  destroy() {
    const instanceIndex = PayBase.instances.indexOf(this);
    if (instanceIndex > -1) {
      PayBase.instances.splice(instanceIndex, 1);
    }
  }

  getConfirmDialogProps() {}
  onAccountStatusSuccess() {}
  onAccountStatusFailed() {}
  sendPayment() {}
}
PayBase.instances = [];
svs.tur.payment.base.Pay = PayBase;

 })(window);